export enum EngagementMeetingsPhase {
    NotStarted = 0,
    ProvideAvailability = 1,
    // Fresh identifier replacing the retired AgreeOnTimes; combines the former
    // "Agree On Times" (2) and "Meetings Period" (3) phases into one.
    Meetings = 2,
    // 3 retired — was MeetingsPeriod; value AND identifier are never reused.
    Completed = 4,
}

export const EngagementMeetingsPhases = [
    { id: EngagementMeetingsPhase.NotStarted, name: 'Not Started' },
    { id: EngagementMeetingsPhase.ProvideAvailability, name: 'Provide Availability' },
    { id: EngagementMeetingsPhase.Meetings, name: 'Meetings Period' },
    { id: EngagementMeetingsPhase.Completed, name: 'Completed' },
];